import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import TutorialsSection from './components/TutorialsSection';
import SolutionsSection from './components/SolutionsSection';
import CommunitySection from './components/CommunitySection';
import EntrepreneurSection from './components/EntrepreneurSection';
import FooterSection from './components/FooterSection';

const HomePage = () => {
  return (
    <main className="w-full min-h-screen overflow-x-hidden bg-[var(--app-bg)] text-[var(--app-text)] transition-colors duration-300">
      <Navbar />
      <HeroSection />
      <TutorialsSection />
      {/*<SolutionsSection />*/}
      <CommunitySection />
      <EntrepreneurSection />
      <FooterSection />
    </main>
  );
};

export default HomePage;
